import React, { useState } from 'react';
import { Download, FileSpreadsheet } from 'lucide-react';
import { Button } from '../ui/Button';
import { ExportConfig } from '../../types/dashboard';
import { generateExcelExport } from '../../services/reports/excelExport';

interface ExportButtonProps {
  config: ExportConfig;
  disabled?: boolean;
  className?: string;
}

export const ExportButton: React.FC<ExportButtonProps> = ({ config, disabled = false, className }) => {
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    setExporting(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 500));
      generateExcelExport(config);
    } catch (error) {
      console.error('Export failed:', error);
    } finally {
      setExporting(false);
    }
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleExport}
      disabled={disabled || exporting}
      icon={exporting ? <FileSpreadsheet className="w-4 h-4 animate-pulse" /> : <Download className="w-4 h-4" />}
      className={className}
    >
      {exporting ? 'Exporting...' : 'Export Excel'}
    </Button>
  );
};
